const UserTypes = {
  EMPLOYEE: 'E',
  CONTACT: 'C',
  ADMINISTRATOR: 'A',
};

const RoleCodes = {
  ADMIN: 'ADMIN',
  DISPATCH: 'DISPATCH',
  GUARD: 'GUARD',
  MANAGER: 'MANAGER',
  SUPERVISOR: 'SPV',
  A_ADMIN: 'A_ADMIN',
  A_MANAGER: 'A_MANAGER',
  A_DISPATCH: 'A_DISPATCH',
  GUARD_MT: 'GUARD_MT',
};

export {
  UserTypes,
  RoleCodes,
};
